const arrayToString = (arr, field = null) => {
  if (field == null) {
    return arr.toString();
  }
  let text = '';
  arr.forEach(element => {
    text += element[field];
  });
  return text;
};

export default arrayToString;
